export const LogLevel = {
    NonSet: 0,
    Debug: 10,
    Info: 20,
    Warning: 30,
}

export const TOOLTIP_ACTION = 'tooltip_watched'
export const TOOLTIP_TIME_LIMIT = 2


// WEBPACK FOOTER //
// ./helpers/uilogging/constants.js